import { CheckboxGroupField, useText } from "@sveabank/cc-common";
import { usePageContext } from "../../../../hooks/context";
import type { ClcBeneficialOwnerControlType } from "../../../../types/clc-application";
import { useClcCompanyApplication } from "../../hooks";

type Props = {
	name: string;
	isMajorShareholder: boolean;
};

export const BeneficialOwnershipTypeField = ({ name, isMajorShareholder }: Props) => {
	const [t, texts] = useText();
	const { controlTypeMap } = usePageContext(useClcCompanyApplication);

	const fieldName = `${name}.controlTypes`;

	const validateField = (value: Array<string> | undefined) => {
		if (value && value.length > 0) return undefined;
		return t(texts.validation.mandatory);
	};

	return (
		<CheckboxGroupField
			validators={[validateField]}
			legend={t(texts.newCompany.beneficialOwnership.controlTypeHeading)}
			name={fieldName}
			options={controlTypeMap}
			disabledFields={
				isMajorShareholder
					? ["SharesOwnershipAgreement" satisfies ClcBeneficialOwnerControlType]
					: []
			}
		/>
	);
};
